import i18n from 'i18next';
import { makeAutoObservable } from 'mobx';
import { TFunction, TFuncKey } from 'react-i18next';
import { I18NInitOptions, initI18nLocalization } from './i18n';
import { getLanguage } from './utils';

class I18NextStore {
	private _i18n: typeof i18n;

	public get IsInitialized(): boolean {
		return this._i18n !== undefined && this._i18n !== null && this._i18n.isInitialized;
	}

	public get I18n(): typeof i18n {
		if (!this.IsInitialized) {
			throw new Error('I18NextStore needs to be initialized first');
		}

		return this._i18n;
	}

	public get t(): TFunction {
		return this.I18n.t;
	}

	constructor() {
		this._i18n = null;
		makeAutoObservable(this);
	}

	async init(initOptions?: I18NInitOptions): Promise<I18NextStore> {
		if (this.IsInitialized) {
			return this.locale().then(() => this);
		}

		return initI18nLocalization(initOptions).then((_i18n) => {
			this._i18n = _i18n;
			return this;
		});
	}

	/**
	 *
	 * @param language if not set, it takes the result of default language order [token, navigator, default]
	 */
	async locale(language?: string): Promise<TFunction> {
		return this.I18n.changeLanguage(language || getLanguage());
	}
}

export type { TFunction, TFuncKey };
export { I18NextStore };
export const i18NextStore = new I18NextStore();
